import CLLocalStorage from '../localStorage/CLLocalStorage';
import {Routes} from '../routing/routing.config';
import authApi from './auth.api';
import {SignOutParams, UserAuthBaseInfo} from './auth.types';
import {
  LS_KEY__BG_PROCESSES,
  LS_KEY__CLIENT_ID,
  LS_KEY__CLINCH_TOKEN,
} from '../localStorage/CLLocalStorage.consts';

function getUserAuth(): UserAuthBaseInfo {
  const searchParams = new URLSearchParams(location.search);
  const authFromUrlParams = {clientId: +searchParams.get('cid'), token: searchParams.get('token')};

  return {
    clientId:
      authFromUrlParams.clientId || getClientIdFromUrl() || +CLLocalStorage.get(LS_KEY__CLIENT_ID),
    token: CLLocalStorage.get(LS_KEY__CLINCH_TOKEN),
    guestToken: authFromUrlParams.token,
  };
}

function getClientId() {
  return getUserAuth().clientId;
}

function setUserAuth({clientId, token}: UserAuthBaseInfo) {
  CLLocalStorage.set(LS_KEY__CLIENT_ID, clientId.toString());
  CLLocalStorage.set(LS_KEY__CLINCH_TOKEN, token);
}

function revokeUser() {
  _clearUserToken();
  _clearUserBgProcesses();
}

async function signOutUser(params?: SignOutParams) {
  const singleSignOutRedirectUrl = await authApi.logout();

  if (params?.clearClientId) _clearClientId();
  revokeUser();

  window.location.href = params?.redirectUrl ?? singleSignOutRedirectUrl ?? Routes.Login;
}

function _clearUserToken() {
  CLLocalStorage.remove(LS_KEY__CLINCH_TOKEN);
}

function _clearClientId() {
  CLLocalStorage.remove(LS_KEY__CLIENT_ID);
}

function _clearUserBgProcesses() {
  CLLocalStorage.remove(LS_KEY__BG_PROCESSES);
}

function setClientId(clientId: number) {
  CLLocalStorage.set(LS_KEY__CLIENT_ID, clientId.toString());
}

function setToken(token: string) {
  CLLocalStorage.set(LS_KEY__CLINCH_TOKEN, token);
}

function isLoggedIn() {
  const {clientId, token} = getUserAuth();

  return !!(clientId && token);
}

function getClientIdFromUrl() {
  const {pathname} = window.location;

  return +pathname.replace(/\/acc\/(\d+)\/.+/, '$1');
}

export {
  getUserAuth,
  getClientId,
  setClientId,
  setToken,
  setUserAuth,
  isLoggedIn,
  signOutUser,
  revokeUser,
  getClientIdFromUrl,
};
